import "./style/history.css";
import { useContext } from 'react'
import { AppMainContext } from '../context/AppMainContext';
import { useNavigate } from "react-router-dom";
import HistoryCalendar from "./HistoryCalendar";

export default function History() {
  const {currentUser} = useContext(AppMainContext);
  const nav = useNavigate();

  return (
    <div className="history_div">
      <div className="history_backBtn_div">
        <button className="history_backBtn" onClick={()=>{nav(`/${currentUser.id}/myTasks`)}}>חזור</button>
      </div>
      <h1 className="history_header">היסטוריה</h1>
      <HistoryCalendar history={currentUser.history} />
    </div>
  )
}
